import { FormEvent } from 'react';
import { IVersionedFile } from '@nkr/models/index';
import { Col, FormGroup, ControlLabel } from 'react-bootstrap';
import { IFileItem } from './file-item';

interface IProps {
    typeList: IFileItem[],
    fileList: IVersionedFile[],
    onFileDownload: (e: FormEvent<HTMLAnchorElement>) => void
}

const SectionList = (props: IProps) => {
    return (
        <>
            {props.typeList.map(item => {
                let docsByType = props.fileList.filter(x => x.entityType == item.entityType);

                return (
                    <FormGroup>
                        <Col xs={12} sm={6} componentClass={ControlLabel}>{item.label}:</Col>
                        <Col xs={12} sm={6}>
                            {docsByType != null && docsByType.map(doc =>
                                <div className='form-control-static'>
                                    {doc != null ?
                                        <a id={doc.id.toString()} style={{ cursor: 'default' }} target='_blank' onClick={props.onFileDownload}>View {doc.documentsVersion.versionNumber}</a>
                                        :
                                        <div>- not uploaded -</div>
                                    }
                                </div>
                            )}

                            {docsByType.length == 0 &&
                                <div className='form-control-static'>
                                    <div>- not uploaded -</div>
                                </div>
                            }
                        </Col>
                    </FormGroup>
                );
            })}
        </>
    );
}

export default SectionList;